import React from 'react'
import { SearchState } from './searchState'
import { SearchBlock } from './searchBlock'
import { ComponentPageheader } from '../../../Styleguide/structure/custom/components/pageheaders'
import { PaginationLayout } from '../../pagination/paginationLayout'
import i18next from 'i18next'
import { datalayerHandler } from '../../utils/datalayer'
import { maybeToMailPlusLink } from '../../utils/mailplus'
import { formatDateDDMonthYYYY } from '../../utils/date'
import { Link } from 'widgets-for-react'

export const SearchLayout = (props: SearchState) => {
  const location = window.location
  // @todo: get rid of useeffect
  React.useEffect(() => {
    document.title = i18next.t('search:search');
  }, []);

  React.useEffect(() => {
    if (props.result.kind === 'loaded') {
      datalayerHandler(
        'search',
        props.result.value.Resources.length > 0 ? 'result' : 'no_result',
        'search',
        { label: props.query })
    }

  }, [props.result.kind]);
  return (
    <>
      {ComponentPageheader(false, false, {
        title: i18next.t('search:search')
      }).run(() => {})}

      <SearchBlock
        query={props.query || ""}
        page={props.page || 1}
        disabled={props.result.kind === 'loading'} />

      <div className="block block--listing">
        <div className="block__inner container--s spacing--mx gutter--m">
          <h2 className="sr-text">{i18next.t('common:search')}</h2>

          {props.query && props.result.kind === 'loaded' ?
            <div className="block__content">
              <section className="listing">
                <div className="listing__inner">
                  <header className="listing__header">
                    <h3 className="listing__title title--s">
                      {props.result.kind === 'loaded'
                        ? props.result.value.Total
                        : 0} {i18next.t('search:resultsFound')}
                    </h3>
                  </header>

                  <div className="listing__content">
                    <ul className="listing__list">
                      {(props.result.kind === 'loaded'
                        ? props.result.value.Resources
                        : []).map(r => (
                          <li className="listing__item" key={r.Resource.AbsolutePath}>
                            <Link
                              className="listing__link"
                              to={r.Resource.AbsolutePath}
                              onClick={() =>
                                datalayerHandler('search_ctr', 'yes', 'search_ctr', {
                                  kind: 'link',
                                  label: r.Resource.HeaderTitle,
                                  link: maybeToMailPlusLink(r.Resource.AbsolutePath)
                                })}>
                              <article className="listingitem">
                                <header className="listingitem__header">
                                  <p className="listingitem__label label--m">{i18next.t(`contentType:${r.Resource.ContentType.replace(/\s+/g, '')}`)}</p>
                                  <h4 className="listingitem__title title--m highlight-em" dangerouslySetInnerHTML={{__html: r.Highlight.HeaderTitle && r.Highlight.HeaderTitle.length > 0 ? r.Highlight.HeaderTitle[0] : r.Resource.HeaderTitle}} />
                                  {r.Resource.PublicationDate && r.Resource.ContentType == "Actuality page" &&
                                    <time className="listingitem__date text--m" dateTime={r.Resource.PublicationDate.toString()}>{formatDateDDMonthYYYY(i18next, r.Resource.PublicationDate)}</time>
                                  }
                                </header>

                                <div className="listingitem__content">
                                  <div className="listingitem__intro text--l highlight-em" dangerouslySetInnerHTML={{__html: r.Highlight.HeaderDescription && r.Highlight.HeaderDescription.length > 0 ? r.Highlight.HeaderDescription[0] : r.Resource.HeaderDescription}} />
                                </div>
                              </article>
                            </Link>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              </section>
            </div> : null
          }
        </div>
      </div>
      {props.result.kind === 'loaded' && <PaginationLayout
        currentPage={props.page || 1}
        totalPages={Math.ceil(props.result.value.Total / props.result.value.PerPage)}
        toPage={page => `${location.pathname}?${new URLSearchParams({page: page.toString(), search: props.query || '' }).toString()}`}
      />}

    </>
  )
}
